module.exports = __webpack_public_path__ + "static/media/bg_serie.47275ad5.svg";